var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPausedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 4.41667V19.5833C14.5013 20.1254 14.5013 20.3965 14.5461 20.6219C14.7303 21.5475 15.4533 22.2714 16.3789 22.4556C16.6043 22.5004 16.8754 22.5004 17.4175 22.5004C17.9595 22.5004 18.2316 22.5004 18.457 22.4556C19.3826 22.2714 20.1061 21.5475 20.2902 20.6219C20.3346 20.3985 20.3346 20.1302 20.3346 19.5976V4.40239C20.3346 3.86979 20.3346 3.60101 20.2902 3.3776C20.1061 2.45199 19.3821 1.72895 18.4565 1.54483C18.2311 1.5 17.9601 1.5 17.418 1.5C16.8759 1.5 16.6043 1.5 16.3789 1.54483C15.4533 1.72895 14.7303 2.45199 14.5461 3.3776C14.5013 3.603 14.5013 3.87457 14.5013 4.41667Z",
    stroke: "#AF976E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 4.41667V19.5833C1.66797 20.1254 1.66797 20.3965 1.7128 20.6219C1.89692 21.5475 2.61996 22.2714 3.54557 22.4556C3.77097 22.5004 4.04202 22.5004 4.58412 22.5004C5.12621 22.5004 5.3983 22.5004 5.6237 22.4556C6.54931 22.2714 7.27275 21.5475 7.45687 20.6219C7.50131 20.3985 7.50131 20.1302 7.5013 19.5976V4.40239C7.50131 3.86979 7.50131 3.60101 7.45687 3.3776C7.27275 2.45199 6.54879 1.72895 5.62318 1.54483C5.39778 1.5 5.12673 1.5 4.58464 1.5C4.04254 1.5 3.77097 1.5 3.54557 1.54483C2.61996 1.72895 1.89692 2.45199 1.7128 3.3776C1.66797 3.603 1.66797 3.87457 1.66797 4.41667Z",
    stroke: "#AF976E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedStatus);
export default __webpack_public_path__ + "static/media/paused_status.68cada3e139c4763a0789e2c1c764989.svg";
export { ForwardRef as ReactComponent };